import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2db80316"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "jtv-search-nav"
}
const _hoisted_2 = {
  class: "jtv-search-count",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "jtv-search-path-root" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "jtv-search-path-separator",
  "aria-hidden": "true"
}, "›", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = { class: "jtv-search-path-root" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "jtv-search-path-separator",
  "aria-hidden": "true"
}, "›", -1))
const _hoisted_10 = {
  key: 1,
  ref: "pathMeasureRef",
  class: "jtv-search-path jtv-search-path--measure",
  "aria-hidden": "true"
}
const _hoisted_11 = { class: "jtv-search-path-root" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jtv-search-path-separator" }, "›", -1))
const _hoisted_13 = {
  key: 1,
  class: "jtv-search-empty",
  role: "status",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ElInput = _resolveComponent("ElInput")!
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_ElButtonGroup = _resolveComponent("ElButtonGroup")!
  const _component_JsonTreeViewItem = _resolveComponent("JsonTreeViewItem")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jtv-container", { 'jtv-narrow': _ctx.isNarrow }]),
    style: _normalizeStyle({ '--jtv-indent-step': _ctx.indentStep + 'px' }),
    ref: "containerRef"
  }, [
    (_ctx.searchable)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["jtv-toolbar", {
        'jtv-toolbar--dark': _ctx.colorScheme === 'dark',
        'jtv-toolbar--popup': _ctx.isPopupContext,
      }]),
          ref: "toolbarRef"
        }, [
          _createElementVNode("div", {
            class: "jtv-search",
            role: "search",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createVNode(_component_ElInput, {
              modelValue: _ctx.query,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
              class: "jtv-search-input",
              placeholder: _ctx.t('Common.SearchOutput'),
              "aria-label": _ctx.t('Common.SearchOutput'),
              clearable: "",
              size: "small",
              onKeydown: [
                _withKeys(_withModifiers(_ctx.onEnterKey, ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(_ctx.clearSearch, ["prevent"]), ["esc"])
              ],
              onClear: _ctx.clearSearch
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  icon: "search",
                  class: "jtv-search-icon"
                })
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder", "aria-label", "onKeydown", "onClear"]),
            (_ctx.isSearchActive)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.countLabel), 1),
                  _createVNode(_component_ElButtonGroup, { class: "jtv-search-btns" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ElTooltip, {
                        effect: "custom",
                        content: _ctx.t('Common.Previous'),
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElButton, {
                            size: "small",
                            disabled: !_ctx.hasResults,
                            "aria-label": _ctx.t('Common.Previous'),
                            onClick: _ctx.goPrev
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "chevron-up" })
                            ]),
                            _: 1
                          }, 8, ["disabled", "aria-label", "onClick"])
                        ]),
                        _: 1
                      }, 8, ["content"]),
                      _createVNode(_component_ElTooltip, {
                        effect: "custom",
                        content: _ctx.t('Common.Next'),
                        placement: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElButton, {
                            size: "small",
                            disabled: !_ctx.hasResults,
                            "aria-label": _ctx.t('Common.Next'),
                            onClick: _ctx.goNext
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "chevron-down" })
                            ]),
                            _: 1
                          }, 8, ["disabled", "aria-label", "onClick"])
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 32),
          (_ctx.isSearchActive && _ctx.hasResults)
            ? (_openBlock(), _createBlock(_component_ElTooltip, {
                key: 0,
                effect: "custom",
                placement: "bottom",
                "show-after": 250,
                disabled: !_ctx.shouldShowPathTooltip
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "jtv-search-path-tooltip scrollable-tooltip-content overflow-auto",
                    "aria-label": _ctx.activePathLabel
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t("Flow.OutputData")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePathSegments, (segment, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `tooltip-${segment.label}-${index}`
                      }, [
                        _hoisted_5,
                        _createElementVNode("span", {
                          class: _normalizeClass(["jtv-search-path-segment", {
                'jtv-search-path-segment--index': segment.isArrayIndex,
                'jtv-search-path-segment--current':
                  index === _ctx.activePathSegments.length - 1,
              }])
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.splitIdentifier(segment.label), (piece, pieceIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `${piece.text}-${pieceIndex}`
                            }, [
                              (piece.breakBefore)
                                ? (_openBlock(), _createElementBlock("wbr", _hoisted_6))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(piece.text), 1)
                            ], 64))
                          }), 128))
                        ], 2)
                      ], 64))
                    }), 128))
                  ], 8, _hoisted_3)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    ref: "pathRef",
                    class: "jtv-search-path",
                    "aria-label": _ctx.activePathLabel
                  }, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.t("Flow.OutputData")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePathSegments, (segment, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `${segment.label}-${index}`
                      }, [
                        _hoisted_9,
                        _createElementVNode("span", {
                          class: _normalizeClass(["jtv-search-path-segment", {
              'jtv-search-path-segment--index': segment.isArrayIndex,
              'jtv-search-path-segment--ellipsis': segment.isEllipsis,
              'jtv-search-path-segment--current':
                index === _ctx.visiblePathSegments.length - 1,
            }])
                        }, _toDisplayString(segment.label), 3)
                      ], 64))
                    }), 128))
                  ], 8, _hoisted_7)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.isSearchActive && _ctx.hasResults)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t("Flow.OutputData")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePathSegments, (segment, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: `measure-${segment.label}-${index}`
                  }, [
                    _hoisted_12,
                    _createElementVNode("span", {
                      class: _normalizeClass(["jtv-search-path-segment", {
            'jtv-search-path-segment--index': segment.isArrayIndex,
          }])
                    }, _toDisplayString(segment.label), 3)
                  ], 64))
                }), 128))
              ], 512))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.searchable && _ctx.isSearchActive && !_ctx.hasResults)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.t("Common.NoResultsFound")), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_JsonTreeViewItem, {
      class: _normalizeClass([{ 'root-item': true, dark: _ctx.colorScheme === 'dark' }]),
      data: _ctx.renderTree,
      maxDepth: _ctx.maxDepth,
      objectMap: _ctx.map,
      tab: _ctx.tab,
      path: _ctx.path,
      element: _ctx.element,
      onSelected: _ctx.itemSelected,
      clickAbleDataType: _ctx.clickAbleDataType,
      "search-query": _ctx.debouncedQuery,
      "active-search-path": _ctx.activePath,
      "has-active-search-match": _ctx.hasResults,
      "expanded-paths": _ctx.expandedPaths
    }, null, 8, ["class", "data", "maxDepth", "objectMap", "tab", "path", "element", "onSelected", "clickAbleDataType", "search-query", "active-search-path", "has-active-search-match", "expanded-paths"])
  ], 6))
}